var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Prop, Vue, } from "vue-property-decorator";
import PartInformation from "../../components/projecttablerows/partinformation.vue";
let PartInformationRow = class PartInformationRow extends Vue {
    articleDataChange(b) { return b; }
};
__decorate([
    Emit()
], PartInformationRow.prototype, "articleDataChange", null);
__decorate([
    Prop({ required: true })
], PartInformationRow.prototype, "numberOfColumns", void 0);
__decorate([
    Prop({ required: true })
], PartInformationRow.prototype, "projectEntry", void 0);
__decorate([
    Prop({ required: true })
], PartInformationRow.prototype, "Renderer3d", void 0);
__decorate([
    Prop({ required: true })
], PartInformationRow.prototype, "shopConfig", void 0);
PartInformationRow = __decorate([
    Component({
        components: {
            PartInformation,
        },
        name: "PartInformationRow",
    })
], PartInformationRow);
export default PartInformationRow;
